<template>
  <div class="col s12 z-depth-1 white">
    <!--<EventList events=""/>-->
    <div class="col s12">
      <div class="row">
        <div class="left" style="padding-top: 10px">
          <span class="title" style="padding-left: 11px;">{{ $t('views.switch.alarms.header') }}</span><br />
          <span class="title-extended"
                style="padding-left: 11px;">{{ $t('views.switch.alarms.subheader') }}</span>
        </div>
      </div>
    </div>
    <!-- Alarms with boundaries -->
    <div class="row"  v-if="measurementsWithBoundaries.length > 0">
      <div class="col s12">
        <table class="striped highlight">
          <thead class="colheaderrow">
            <tr>
              <th class="listViewcell">
                <span class="colheader">{{ $t('views.switch.switchevents.filter.severity') }}</span>
              </th>
              <th class="listViewcell">
                <span class="colheader">{{ $t('views.switch.alarmsettings.section') }}</span>
              </th>
              <th class="listViewcell">
                <span class="colheader">{{ $t('views.switch.alarmsettings.section') }} {{ $t('views.switch.alarmsettings.boundarries') }}</span>
              </th>
              <th class="listViewcell">
                <span class="colheader">{{ $t('views.switch.alarmsettings.analysemethod') }}</span>
              </th>
              <th class="listViewcell">
                <span class="colheader">{{ $t('views.switch.alarmsettings.measurement') }}</span>
              </th>
              <th class="listViewcell">
                <span class="colheader">{{ $t('views.switch.alarmsettings.threshold') }}</span>
              </th>
               <th class="listViewcell">
                <span class="colheader">{{ $t('views.switch.alarmsettings.source') }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in measurementsWithBoundaries" :key="index">
              <td class="listViewcell">
                        <span>
                        <i v-if="item.SeverityId === 3" class="material-icons legend-icon tiny status-alarm">warning</i>
                        <i v-if="item.SeverityId === 2" class="material-icons legend-icon tiny status-warning">error_outline</i>
                        </span>
              </td>
              <td class="listViewcell">
                <span v-if="event && event.Id === item.Id" @click="deselect" class="visibility">
                  <i class="material-icons tiny">
                    visibility_off
                  </i>
                </span>
                <span v-else @click="select(item)" class="visibility">
                  <i class="material-icons tiny">
                    visibility
                  </i>
                </span>
                <span class="body1">{{ item.SectionName }}</span>
              </td>
              <td class="listViewcell">
                <span class="body1">{{ item.SectionBoundaries }}</span>
              </td>
              <td class="listViewcell">
                <span class="body1">{{ item.AnalyseThresholds.AnalyseMethodType }}</span>
              </td>
              <td class="listViewcell">
                <span class="body1">{{ item.Value }}</span>
              </td>
              <td class="listViewcell">
                <span v-if="item.SeverityId === 3" class="body1">{{ item.AnalyseThresholds.Error.Txt }}</span>
                <span v-if="item.SeverityId === 2"
                      class="body1">{{ item.AnalyseThresholds.Warning.Txt }}</span>
              </td>
              <td class="listViewcell">
                <span class="body1">{{ item.Source }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Alarms with free text -->
    <div class="row"  v-if="measurementsWithText.length > 0">
      <div class="col s12">
        <table class="striped highlight">
          <thead class="colheaderrow">
            <tr>
              <th class="listViewcell">
                <span class="colheader">{{ $t('views.switch.switchevents.filter.severity') }}</span>
              </th>
              <th class="listViewcell">
                <span class="colheader">{{ $t('views.switch.alarmsettings.section') }}</span>
              </th>
              <th class="listViewcell">
                <span class="colheader">{{ $t('views.switch.alarmsettings.section') }} {{ $t('views.switch.alarmsettings.boundarries') }}</span>
              </th>
              <th class="listViewcell">
                <span class="colheader">{{ $t('views.switch.alarmsettings.analysemethod') }}</span>
              </th>
              <th class="listViewcell">
                <span class="colheader">{{ $t('views.switch.alarmsettings.measurement') }}</span>
              </th>
               <th class="listViewcell">
                <span class="colheader">{{ $t('views.switch.alarmsettings.source') }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in measurementsWithText" :key="index">
              <td class="listViewcell">
                        <span>
                        <i v-if="item.SeverityId === 3" class="material-icons legend-icon tiny status-alarm">warning</i>
                        <i v-if="item.SeverityId === 2" class="material-icons legend-icon tiny status-warning">error_outline</i>
                        </span>
              </td>
              <td class="listViewcell">
                <span class="body1">{{ item.SectionName }}</span>
              </td>
              <td class="listViewcell">
                <span class="body1">{{ item.SectionBoundaries }}</span>
              </td>
              <td class="listViewcell">
                <span class="body1">{{ item.AnalyseThresholds.AnalyseMethodType }}</span>
              </td>
              <td class="listViewcell">
                <span class="body1">{{ item.FreeText }}</span>
              </td>
              <td class="listViewcell">
                <span class="body1">{{ item.Source }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'EventDetails',
  props: {
    measurementEvents: {
      required: false,
      default: []
    },
    event: {
      required: false,
      default: null
    }
  },
  methods: {
    select (item) {
      return this.$emit('on-select', item)
    },
    deselect () {
      this.$emit('on-select', null)
    },
    filterHasBoundaries (measurement) {
      if (measurement.Source === 'R8') {
        return false
      }

      if (measurement.AnalyseThresholds.Error && measurement.AnalyseThresholds.Warning &&
          (measurement.AnalyseThresholds.Error.IsSet || measurement.AnalyseThresholds.Warning.IsSet)) {
        return true
      }

      return false
    }
  },
  computed: {
    measurementsWithBoundaries () {
      return this.measurementEvents.filter(m => this.filterHasBoundaries(m))
    },
    measurementsWithText () {
      return this.measurementEvents.filter(m => !this.filterHasBoundaries(m))
    }
  }
}
</script>

<style scoped>

  .status-warning {
    color: #FFA842;
  }

  .status-alarm {
    color: #C91414
  }

  .visibility {
    cursor: pointer;
  }

  .title {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    font-size: 20px;
    line-height: 23px;
    color: rgba(0, 0, 0, 0.87);
  }

  .title-extended {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    font-size: 20px;
    line-height: 23px;
    color: rgba(0, 0, 0, 0.4);
  }

  .body1 {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    line-height: 20px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
  }

  .colheaderrow {
    border-top: 1px solid #E0E0E0;
    border-bottom: 1px solid #E0E0E0;
  }

  .colheader {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    line-height: 20px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.4)
  }

  .listViewcell {
    padding-top: 2px !important;
    padding-bottom: 2px !important;
  }

  table.highlight tbody tr:hover {
    background-color: #eee !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/switch/EventDetails.vue